import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81ccbaa8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex flex-row w-full pt-2 pb-3 mt-10 divide-x divide-slate-300 border-b border-slate-300 relative",
  style: {"text-shadow":"white 1px 1px 0"}
}
const _hoisted_2 = { class: "w-1/3 text-center border-l border-slate-300" }
const _hoisted_3 = { class: "text-6xl font-bold leading-100 text-slate-700" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, "Your Total Portfolio Value", -1))
const _hoisted_5 = { class: "w-1/3 text-center" }
const _hoisted_6 = { class: "text-6xl font-bold leading-100 text-slate-700" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, "Today's Portfolio Change", -1))
const _hoisted_8 = { class: "w-1/3 text-center border-r border-slate-300" }
const _hoisted_9 = { class: "text-6xl font-bold leading-100 text-slate-700" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, "All-time Portfolio Change", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-[1px] h-full absolute right-0 border-r bottom-3" }, null, -1))
const _hoisted_12 = { class: "flex flex-col" }
const _hoisted_13 = {
  key: 0,
  class: "flex flex-row grow mt-3"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pt-10 mb-1 mt-8 font-ammocorps text-slate-500 text-2xl border-t" }, "Popular Markets", -1))
const _hoisted_15 = { class: "grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_WithTooltip = _resolveComponent("WithTooltip")!
  const _component_InlineSvg = _resolveComponent("InlineSvg")!
  const _component_ProductOverlay = _resolveComponent("ProductOverlay")!
  const _component_CommodityRecord = _resolveComponent("CommodityRecord")!
  const _component_ContentWrapper = _resolveComponent("ContentWrapper")!
  const _component_BasicLayout = _resolveComponent("BasicLayout")!
  const _component_OverlayHowItWorksVideo = _resolveComponent("OverlayHowItWorksVideo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BasicLayout, null, {
      default: _withCtx(() => [
        _createVNode(_component_ContentWrapper, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_WithTooltip, { offset: -25 }, {
                  tooltip: _withCtx(() => [
                    _createTextVNode(" Value of all ammo holdings in your account. Based on most recent executed USAE trade price for holdings you own. Does not include cash on hand. ")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: "/account/asset-management",
                      class: "block mx-3 pt-5 pb-12 hover:bg-[#EBEFF5]"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_3, "$" + _toDisplayString(typeof _ctx.dashboardStats.currentValue === 'string' || _ctx.dashboardStats.currentValue === undefined ? _ctx.dashboardStats.currentValue : _ctx.addCommas(Math.round(_ctx.dashboardStats.currentValue / 10) / 100)), 1),
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_WithTooltip, { offset: -25 }, {
                  tooltip: _withCtx(() => [
                    _createTextVNode(" Change in value of your ammo holdings since this morning. Increase/decrease is difference between this morning's price and the most recent trade price on USAE. ")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: "/",
                      class: "block mx-3 pt-5 pb-12 hover:bg-[#EBEFF5]"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_6, [
                          _createTextVNode(_toDisplayString(_ctx.dashboardStats.todayChange) + "% ", 1),
                          (_ctx.dashboardStats.todayChange > 0)
                            ? (_openBlock(), _createBlock(_component_InlineSvg, {
                                key: 0,
                                src: require(`@/assets/icons/arrow-up.svg`),
                                width: "20",
                                class: "inline relative -top-1.5"
                              }, null, 8, ["src"]))
                            : (_ctx.dashboardStats.todayChange < 0)
                              ? (_openBlock(), _createBlock(_component_InlineSvg, {
                                  key: 1,
                                  src: require(`@/assets/icons/arrow-down.svg`),
                                  width: "20",
                                  class: "inline relative -top-1.5"
                                }, null, 8, ["src"]))
                              : _createCommentVNode("", true)
                        ]),
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_WithTooltip, { offset: -25 }, {
                  tooltip: _withCtx(() => [
                    _createTextVNode(" Change in value of your ammo holdings since you bought. Increase/decrease is difference between your original purchase price and most recent trade price on USAE. ")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: "/",
                      class: "block mx-3 pt-5 pb-12 hover:bg-[#EBEFF5]"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_9, [
                          _createTextVNode(_toDisplayString(_ctx.dashboardStats.alltimeChange) + "% ", 1),
                          (_ctx.dashboardStats.alltimeChange > 0)
                            ? (_openBlock(), _createBlock(_component_InlineSvg, {
                                key: 0,
                                src: require(`@/assets/icons/arrow-up.svg`),
                                width: "20",
                                class: "inline relative -top-1.5"
                              }, null, 8, ["src"]))
                            : (_ctx.dashboardStats.alltimeChange < 0)
                              ? (_openBlock(), _createBlock(_component_InlineSvg, {
                                  key: 1,
                                  src: require(`@/assets/icons/arrow-down.svg`),
                                  width: "20",
                                  class: "inline relative -top-1.5"
                                }, null, 8, ["src"]))
                              : _createCommentVNode("", true)
                        ]),
                        _hoisted_10
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _hoisted_11
            ]),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([{ name: 'RFL', key: 'rifle'}, { name: 'HND', key: 'handgun'}, { name: 'RMF', key: 'rimfire'}], (category) => {
              return _createElementVNode("div", _hoisted_12, [
                (_ctx.productsByGunTypeId[category.key])
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsByGunTypeId[category.key], (product) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: _normalizeClass([`${_ctx.productClass(product.id)} hover:${_ctx.productClassHover(product.id)}`, "grow"])
                        }, [
                          _createVNode(_component_ProductOverlay, {
                            productId: product.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_router_link, {
                                to: `/products/${product.id}`,
                                class: "block w-full h-6 border-l border-white"
                              }, null, 8, ["to"])
                            ]),
                            _: 2
                          }, 1032, ["productId"])
                        ], 2))
                      }), 256))
                    ]))
                  : _createCommentVNode("", true)
              ])
            }), 64)),
            _hoisted_14,
            _createElementVNode("ul", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commodities, (commodity, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: commodity.id,
                  class: _normalizeClass([ i > 2 ? 'hidden sm:block' : ''])
                }, [
                  _createVNode(_component_CommodityRecord, {
                    id: commodity.id,
                    record: commodity,
                    marketSummary: _ctx.marketSummariesById[commodity.id]
                  }, null, 8, ["id", "record", "marketSummary"])
                ], 2))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayHowItWorksVideo)
  ], 64))
}